export function Footer() {
  return (
    <footer className="shrink-0 w-full border-t border-white/[0.06] mt-auto">
      <div className="w-full max-w-[1480px] mx-auto px-4 py-4">
        <span className="text-muted text-sm">© {new Date().getFullYear()} Lustbucket</span>
      </div>
    </footer>
  );
}
